// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M22 4.5L22 19.5C22 19.5 17 18 12 18C7 18 2 19.5 2 19.5L2 4.5C2 4.5 7 6 12 6C17 6 22 4.5 22 4.5Z","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"panorama-horizontal"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 4.5L22 19.5C22 19.5 17 18 12 18C7 18 2 19.5 2 19.5L2 4.5C2 4.5 7 6 12 6C17 6 22 4.5 22 4.5Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 4.5L22 19.5C22 19.5 17 18 12 18C7 18 2 19.5 2 19.5L2 4.5C2 4.5 7 6 12 6C17 6 22 4.5 22 4.5Z","strokeWidth":"props.strokeWidth"}}]}]};

const PanoramaHorizontalIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'panorama-horizontal',
    ref,
    icon: element,
  },
));

PanoramaHorizontalIcon.displayName = 'PanoramaHorizontalIcon';

export default PanoramaHorizontalIcon;
